import React from 'react'
import styled from 'styled-components'
require('prismjs/themes/prism.css')

const Body = styled.div`
  margin: 0 auto;
  max-width: ${props => props.theme.sizes.maxWidthCentered};

  h1,
  h2,
  h3 {
    font-weight: 600;
    line-height: 1.25;
    margin: 3rem 0 1rem;
  }

  h1 {
    font-size: 1.5em;
  }
  h2 {
    font-size: 1.25em;
    padding: 0.7em;
    background: #dff3ff;
    border-radius: 2px;
    border-left: solid 3px ${props => props.theme.colors.highlight};
  }
  h3 {
    font-size: 1.1em;
  }

  p {
    line-height: 1.9;
    margin: 0 0 2em 0;
  }

  a {
    transition: 0.2s;
    color: ${props => props.theme.colors.base};
    &:hover {
      color: ${props => props.theme.colors.highlight};
    }
  }

  del {
    text-decoration: line-through;
  }
  strong {
    font-weight: 600;
  }
  em {
    font-style: italic;
  }

  ul,
  ol {
    margin: 1em 0;
    ul,
    ol {
      margin: 0.3em 0;
    }
    p {
      margin: 0;
    }
  }

  ul {
    & > li {
      list-style: none;
      list-style-position: inside;
      position: relative;
      line-height: 1.9;
      padding-left: 17px;
      margin: 0.3em 0;
      &:before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 12px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: ${props => props.theme.colors.highlight};
      }
    }
  }

  ol {
    counter-reset: number;
    & > li {
      list-style: none;
      list-style-position: inside;
      position: relative;
      line-height: 1.9;
      padding-left: 30px;
      margin: 0.5em 0;
      &:before {
        display: inline-block;
        position: absolute;
        left: 0;
        top: 2px;
        width: 23px;
        height: 23px;
        border-radius: 50%;
        background: #5c9ee7;
        color: #fff;
        font-family: 'Secular One', sans-serif;
        font-size: 13px;
        text-align: center;
        vertical-align: middle;
        line-height: 23px;
        content: counter(number);
        counter-increment: number;
        background: ${props => props.theme.colors.highlight};
      }
    }
  }

  hr {
    border-style: solid;
    border-color: ${props => props.theme.colors.secondary};
    margin: 0 0 2em 0;
  }

  blockquote {
    font-style: italic;
    border-left: 4px solid ${props => props.theme.colors.secondary};
    padding: 0 0 0 0.5em;
  }

  pre {
    margin: 0 0 2em 0;
    border-radius: 2px;
    padding: 1em;
    background: #eff6ff !important;
    overflow-x: scroll;
    line-height: 1.8;
    font-size: 0.9em;
    span {
      background: inherit !important;
    }
  }
  & > *:first-child {
    margin-top: 0;
  }
`

const PageBody = props => {
  return (
    <Body
      dangerouslySetInnerHTML={{ __html: props.body.childMarkdownRemark.html }}
    />
  )
}

export default PageBody
